import { ZoneSaturationLevelType } from '~globals/types/enums';

export const ZONE_SATURATION_LEVEL_COLORS: Record<
  ZoneSaturationLevelType,
  string
> = {
  [ZoneSaturationLevelType.WithMargin]: '#3f8f5c',
  [ZoneSaturationLevelType.OnAlert]: '#b8894a',
  [ZoneSaturationLevelType.Saturated]: '#b85566',
};

export const getZoneSaturationLevelColor = (
  levelTypeId: ZoneSaturationLevelType,
): string =>
  ZONE_SATURATION_LEVEL_COLORS[levelTypeId] ??
  ZONE_SATURATION_LEVEL_COLORS[ZoneSaturationLevelType.WithMargin];
